<template>
  <div
    :id="
      $route.name == 'WenKu' || $route.name == 'Result'
        ? 'newapp'
        : $route.name == 'NewHome'
        ? 'homeapp'
        : 'app'
    "
    :style="$route.name == 'View' ? { height: '100vh' } : ''"
  >
    <Header v-if="$route.name != 'NewHome'"></Header>

    <router-view></router-view>

    <Footer v-if="$route.name != 'NewHome' && $route.name != 'WenKu'"></Footer>

    <!-- <el-dialog
      v-if="$route.name != 'Login'"
      :visible.sync="loginDialogVisible"
      width="51rem"
      top="20vh"
      :before-close="handleClose"
      custom-class="loginbox"
    >
      <loginBox v-if="$route.name != 'Login'"></loginBox>
    </el-dialog> -->
  </div>
</template>

<script>
import Header from './components/header.vue'
import Footer from './components/footer.vue'

import eventBus from '@/utils/eventBus.js'

import "animate.css"
// import {
//   getArticleList,
//   getInfo
// } from './api/api'
export default {
  components: {
    Header,
    Footer,
    // BindMobile
  },
  name: 'App',
  data: () => {
    return {

      baseUrl: window.__baseUrl__,
      // loginDialogVisible: false,//登录弹窗


    }
  },
  created: function () {
    // getArticleList().then(res => {
    //   console.log(res);
    // })

    // eventBus.$on("doChangeloginVisible", (val) => {
    //   this.doChangeloginVisible(val)
    // })

  },
  mounted () {
    //绑定手机号
    // this.openBindMobileBox()


  },
  methods: {


  }

}
</script>

<style lang="less">
body {
  margin: 0;
}
html {
  font-size: 37.5px;
}

* {
  scrollbar-width: thin;
  scrollbar-color: #eee #ccc;
}

.protected-image {
  -webkit-user-drag: none;
  -moz-user-drag: none;
  -ms-user-drag: none;
  user-drag: none;
  pointer-events: none; /* 可选，完全禁用交互 */
}

.bindbox {
  border-radius: 10px;
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__header {
    padding: 0;
  }
}

// /deep/.el-dialog {
//   border-radius: 12px;
// }
// /deep/.el-dialog__body {
//   padding: 0;
// }
// /deep/.el-dialog__header {
//   padding: 0;
// }

// ::-webkit-scrollbar {
//   width: 8px;
//   // height: 8px;
//   background: #eee;
// }
/*定义滑块 样式*/
::-webkit-scrollbar-thumb {
  // height: 100px; /* 滚动条滑块长度 */
  background-color: #ccc;
}
*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: #eee;
}
/*定义滑块 样式*/
*::-webkit-scrollbar-thumb {
  height: 100px; /* 滚动条滑块长度 */
  background-color: #ccc;
}

#app {
  display: flex;
  flex-direction: column;
  // max-width: 1440px;
  // min-width: 1425px;
  margin: auto;
  width: 100%;
  overflow: hidden;
  font-size: 37.5px;
}

@media screen and (max-width: 768px) {
  #app {
    max-width: 100%;
    min-width: 100%;

    margin: auto;
  }
}
#newapp {
  width: 100%;
  height: 100%;
  font-size: 16px;
  min-width: 1602px;
  overflow: hidden;
  // min-height: 768px;
  // transition: all 4s;
}
#homeapp {
  width: 100%;
  height: 100%;
  font-size: 16px;
  min-width: 800px;
  overflow: hidden;
  // min-height: 768px;
  // transition: all 4s;
}

// body {
//   margin: 0;
//   padding: 0;
// }

// .header {
//   height: 2rem;
//   padding-left: 3rem;
// }

// .menu {
//   width: 3.467rem;
//   height: 0.827rem;
//   background: url(../static/menu/menu_bg.png) 100% no-repeat;
//   background-size: 100% 100%;
// }

// .title {
//   font-size: 0.45rem;
// }
// <style src="./pages/common.css" />
// <style src="./pages/index.css" />
</style>







// WEBPACK FOOTER //
// src/App.vue